import Alpine from "alpinejs";
import listPage from "./listPage";

// suggested in the Alpine docs:
// make Alpine on window available for better DX
window.Alpine = Alpine;

Alpine.data("listPage", listPage);
Alpine.start();
